import AbstractModel, { Model, DateType } from './abstract-model';
import {LexPocAcces, LexPocEtatAcces, LexPocModaliteAcces} from "@/lib/models/gen-lexs";

@Model('CavPocAccesPossible')
export default class CavPocAccesPossible extends AbstractModel {
  public id: number = null;
  public idCavite: string = null;
  @DateType() public quand: Date = null;
  public nom: string = null;
  public lambertOuvrage:number = null;

  public xouvrage:number = null;
  public youvrage:number = null;

  public lexPocTypeAcces:LexPocAcces = null;
  public lexPocModaliteAcces:LexPocModaliteAcces = null;
  public lexPocEtatAcces:LexPocEtatAcces = null;
  public domainePublicPrive:string = null;
  public commentaire: string = null;

}
